import type { IconData } from '@stacksjs/iconify-core'

export const doorFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M42.5 24c0-8.439-.294-13.582-.578-16.584c-.277-2.925-2.486-5.117-5.396-5.406c-2.578-.256-6.62-.51-12.526-.51s-9.948.254-12.526.51c-2.91.29-5.119 2.481-5.396 5.406C5.794 10.418 5.5 15.561 5.5 24s.294 13.582.578 16.584c.277 2.925 2.486 5.117 5.396 5.406c2.578.256 6.62.51 12.526.51s9.948-.254 12.526-.51c2.91-.29 5.119-2.481 5.396-5.406c.284-3.002.578-8.145.578-16.584\"/><path fill=\"#2859c5\" d=\"M26 24a3 3 0 0 1 3-3h4a3 3 0 1 1 0 6h-4a3 3 0 0 1-3-3\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default doorFlat
